// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-ComboBox-MultiSelectComboBox-MultiSelectComboBox-module__emptyStateMessage";
var _2 = "webpack-components-core-ComboBox-MultiSelectComboBox-MultiSelectComboBox-module__inputChevron";
var _3 = "webpack-components-core-ComboBox-MultiSelectComboBox-MultiSelectComboBox-module__inputWrapper";
var _4 = "webpack-components-core-ComboBox-MultiSelectComboBox-MultiSelectComboBox-module__selectedItem";
var _5 = "webpack-components-core-ComboBox-MultiSelectComboBox-MultiSelectComboBox-module__selectionList";
export { _1 as "emptyStateMessage", _2 as "inputChevron", _3 as "inputWrapper", _4 as "selectedItem", _5 as "selectionList" }
